import { init } from '@sentry/vue';

export default defineNuxtPlugin(({ vueApp }) => {
  const runtimeConfig = useRuntimeConfig();
  init({
    dsn: runtimeConfig.public.SENTRY_DSN as string,
    app: vueApp,
    environment: runtimeConfig.public.ENV === 'production' ? 'production' : 'development',
    enabled: runtimeConfig.public.ENV !== 'local',
  });
});
